<template>
  <HLCardLayout ref="cardLayout" disablePadding><!--:background="theme.espotoGrey" -->
    <template #title><span class="black--white" :style="{'color':theme.backgroundColor}">{{labelHighscore}}</span></template>
    <template #action>
      <v-btn
        class=""
        elevation="0"
        icon
        x-large
        @click.stop="refreshHighscore"
        color="rgba(255,255,255,1)"
      >
        <v-icon  opacity="0.5" :color="theme.backgroundColor">
          mdi-cached
        </v-icon>
      </v-btn>
    </template>
    <template #content>
      <HLHighscoreList ref="highscoreList" :eventId="selectedEventId" :height="`${highscoreHeight}px`" :enabled="settingsShowHighscore" :labelPoints="labelPoints"/>
    </template>
  </HLCardLayout>
</template>

<script>
import HLCardLayout from "../../components/dashboard/HLCardLayout.vue";
import HLHighscoreList from "../../components/ui/HLHighscoreList.vue";
import {layoutMixin} from "../../utils/layout-mixin";
import {eventMixin} from "../../utils/event-mixin";

export default {
  mixins: [layoutMixin,eventMixin],
  components:{
    HLCardLayout,
    HLHighscoreList
  },
  data(){
    return {
      highscoreHeight:null
    }
  },
  computed: {
  },
  methods: {
    refreshHighscore(){
      if(this.$refs &&this.$refs.highscoreList){
        this.$refs &&this.$refs.highscoreList.refresh();
      }
    },
    getHighscoreHeight(){
      return (this.$refs &&this.$refs.cardLayout)?this.$refs.cardLayout.getCardContentHeight():null;
    }
  },
  mounted(){
   this.highscoreHeight=this.getHighscoreHeight();
  }
}
</script>
